import { FC } from 'react';

import { Input } from 'ui/components';
import { useFormikContext } from 'formik';
import { Button } from 'ui/components/common';
import { Checkbox, Textarea } from 'ui/components/form';
import { SIZE } from 'utils/constants';
import { cn } from 'utils/helpers';

import { EMAIL_TEMPLATE_FORM } from './schema';

type EmailTemplateFormProps = {
  onCancel?: () => void;
};

const EmailTemplateForm: FC<EmailTemplateFormProps> = ({ onCancel }) => {
  const {
    values,
    touched,
    errors,
    handleChange,
    handleBlur,
    handleSubmit,
    setFieldValue,
    isSubmitting,
  } = useFormikContext<EMAIL_TEMPLATE_FORM>();

  const isFormValid = values.body && values.subject && values.subject;

  return (
    <form onSubmit={handleSubmit}>
      <div className="flex flex-col gap-y-4">
        <Input
          className="w-full"
          type="text"
          name="name"
          size={SIZE.Small}
          textType={errors.name && touched.name ? 'danger' : 'default'}
          onChange={handleChange}
          onBlur={handleBlur}
          value={values.name}
          placeholder="Enter Template Name"
          subText={errors.name && touched.name ? errors.name : undefined}
          label="Name"
          required
          disabled={isSubmitting}
        />
        <Input
          required
          className="w-full"
          type="text"
          name="subject"
          size={SIZE.Small}
          textType={errors.subject && touched.subject ? 'danger' : 'default'}
          onChange={handleChange}
          onBlur={handleBlur}
          value={values.subject ?? ''}
          placeholder="Enter Subject"
          subText={
            errors.subject && touched.subject ? errors.subject : undefined
          }
          label="Subject"
          disabled={isSubmitting}
        />
        <Textarea
          richText
          required
          textType={errors.body && touched.body ? 'danger' : 'default'}
          subText={errors.body && touched.body ? errors.body : undefined}
          label="Body"
          value={values.body ?? ''}
          onChange={(val) => setFieldValue('body', val)}
          rows={3}
          disabled={isSubmitting}
        />
        <Checkbox
          checked={values.isShared}
          onChange={(event) => setFieldValue('isShared', event.target.checked)}
          label="Shared Template"
        />
      </div>
      <div
        className={cn(
          'mt-5 pt-5',
          'flex gap-3 justify-end',
          'border-t-[0.5px] border-separator-primary',
        )}
      >
        <Button
          onClick={onCancel}
          type="button"
          disabled={isSubmitting}
          label="CANCEL"
          intent="tertiary"
          size="sm"
        />
        <Button
          disabled={isSubmitting || !isFormValid}
          label="SAVE"
          type="submit"
          size="sm"
        />
      </div>
    </form>
  );
};

export default EmailTemplateForm;
